



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AdditionalItemsMenu extends Vue {
  @Prop() items: Array<string | number>;

  @Prop({ default: 3 }) numberOfItemsToPreview: number;

  @Prop({ default: 40 }) itemHeight: number;

  @Prop({ default: 300 }) maxHeight: number;

  isMenuOpen = false;

  get itemsOrDefault(): Array<string | number> {
    if (this.items?.length != null) {
      return this.items;
    }
    return [];
  }

  get listItems(): Array<string | number> {
    return this.itemsOrDefault.slice(this.numberOfItemsToPreview);
  }

  get longestStringLength(): number {
    return Math.max(...this.itemsOrDefault.map((item) => item?.toString().length));
  }

  get width(): number {
    // 12 for the average letter length
    // This is a very quick and cheap way to calculate the width
    // Add 10px for padding and border
    return this.longestStringLength * 12 + 10;
  }

  get height(): number {
    return Math.min(this.maxHeight, this.listItems.length * this.itemHeight);
  }

  displayItems(): string {
    let displayedItems = [];
    if (this.itemsOrDefault) {
      displayedItems = this.itemsOrDefault.slice(0, this.numberOfItemsToPreview);
    }
    return displayedItems.join ? displayedItems.join(', ') : '';
  }
}
